function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import PropTypes from 'prop-types';
import _classnames from 'classnames';
var SPACING_PROPS = ['mt', 'mr', 'mb', 'ml', 'mx', 'my', 'pt', 'pr', 'pb', 'pl', 'px', 'py'];
var SIZES = [0, 1, 2, 3, 4, 5, 6];
export default _objectSpread(_objectSpread({}, SPACING_PROPS.reduce(function (props, name) {
  props.propTypes[name] = PropTypes.oneOf(SIZES);
  props.defaultProps[name] = undefined;
  return props;
}, {
  propTypes: {},
  defaultProps: {}
})), {}, {
  classnames: function classnames(props) {
    return _classnames(SPACING_PROPS.reduce(function (classes, spacing) {
      var spacingValue = props[spacing];
      classes["".concat(spacing, "-").concat(spacingValue)] = spacingValue;
      return classes;
    }, {}));
  },
  clean: function clean(props) {
    return Object.keys(props).reduce(function (cleaned, propName) {
      if (!SPACING_PROPS.includes(propName)) {
        cleaned[propName] = props[propName];
      }

      return cleaned;
    }, {});
  }
});